export default {
  page: { limit: 51, offset: 0, hasMore: false },
  flightList: [
    {
      flight: {
        source: "G3",
        GDS: "GWS",
        tripType: "MULTIPLE_SEGMENTS",
        ruleTextReference:
          "eyJidWNrZXQiOiJjZnN0YWNrLWhtbDUtc21pbGVzLWxhbWJkYS1mbGlnaHQtYXZhaWxhYmlsaXR5LWZsaWdodHJ1bGV0ZXh0L0JSQVNJTC8xMzU5OTIyOV8xMDgwMTY4MjMuanNvbiIsICJydWxlVGV4dCI6WyJuODdnMGl3ZGg3bCJdfQ==",
        isInvoluntaryCancel: "false",
        whatsapp: { sendWhatsapp: false, ddi: "", ddd: "", number: "" },
        routeList: [{ originAirportCode: "CGH", destinationAirportCode: "SDU", departureDate: "2023-06-30T06:40:00" }],
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              stops: "0",
              cabin: "ECONOMIC",
              cabinCode: "Y",
              cabinCodeSabre: "Y",
              airline: { code: "G3", name: "GOL" },
              departure: {
                date: "2023-06-30T06:40:00",
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "São Paulo",
                  mac: "SAO",
                  timeZone: "America/Sao_Paulo",
                  state: "São Paulo",
                  country: "Brasil",
                },
              },
              arrival: {
                date: "2023-06-30T07:40:00",
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                  state: "Rio de Janeiro",
                  country: "Brasil",
                },
              },
              duration: { hours: "1", minutes: "0" },
              flightSellKey: "WPMBRL$AC*VOEBIZ$P1ADT$BRLT$RQ",
              legList: [
                {
                  cabin: "ECONOMIC",
                  departure: {
                    date: "2023-06-30T06:40:00",
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "São Paulo",
                      mac: "SAO",
                      timeZone: "America/Sao_Paulo",
                      state: "São Paulo",
                      country: "Brasil",
                    },
                  },
                  arrival: {
                    date: "2023-06-30T07:40:00",
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                      state: "Rio de Janeiro",
                      country: "Brasil",
                    },
                  },
                  flightNumber: "1002",
                  marketingAirline: { code: "G3", name: "GOL" },
                  operationAirline: { code: "G3", name: "GOL" },
                  equipment: "738",
                  isConnection: "false",
                  productClass: "N",
                  statusCode: "HK",
                  operatingProductClass: "N",
                  marketingProductClass: "N",
                  inboundConnection: "false",
                  outboundConnection: "false",
                },
              ],
            },
            recordLocator: "OCEQAP",
            baggageList: {
              passengerBaggage: {
                passenger: {
                  uid: "01.01",
                  index: "0",
                  type: "ADT",
                  firstName: "ALINE LORENA MAITE DA",
                  lastName: "CONCEICAO",
                  tier: "SMILES",
                },
                baggage: {
                  code: "0C9",
                  quantity: "1",
                  amount: "0",
                  weight: "45",
                  maxWeight: "45",
                  keyValue: "EXCESSO DE BAGAGEM POR KILO",
                },
                miles: "0",
                money: "0",
                smilesAndMoneyList: {},
                type: "FREE",
              },
            },
            availableBaggageList: {
              passengerBaggage: [
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA1",
                    quantity: "2",
                    amount: "95",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "PRIMEIRA BAGAGEM",
                  },
                  miles: "6200",
                  money: "95",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "5700", money: "21" },
                      { miles: "5000", money: "32" },
                      { miles: "2200", money: "74" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA2",
                    quantity: "3",
                    amount: "224",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "SEGUNDA BAGAGEM",
                  },
                  miles: "14600",
                  money: "224",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "13500", money: "50" },
                      { miles: "11800", money: "74" },
                      { miles: "5100", money: "173" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA3",
                    quantity: "4",
                    amount: "404",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "TERCEIRA BAGAGEM",
                  },
                  miles: "26300",
                  money: "404",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "24300", money: "89" },
                      { miles: "21300", money: "134" },
                      { miles: "9100", money: "312" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA4",
                    quantity: "5",
                    amount: "584",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "QUARTA A QUINTA BAGAGEM CADA",
                  },
                  miles: "38000",
                  money: "584",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "35100", money: "129" },
                      { miles: "30700", money: "193" },
                      { miles: "13200", money: "450" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA5",
                    quantity: "6",
                    amount: "764",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "QUARTA A QUINTA BAGAGEM CADA",
                  },
                  miles: "49700",
                  money: "764",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "45900", money: "169" },
                      { miles: "40200", money: "253" },
                      { miles: "17200", money: "589" },
                    ],
                  },
                  type: "AVAILABLE",
                },
              ],
            },
            checkin: "UNAVAILABLE",
            travelType: "NATIONAL",
            isAllowedBaggage: "true",
            migratedRecordLocator: "OCEQAP",
            passengerList: [
              {
                index: "0",
                type: "ADT",
                firstName: "ALINE LORENA MAITE DA",
                lastName: "CONCEICAO",
                gender: "FEMALE",
                birthday: "1999-01-01",
                email: "TESTE1NOVO2023@GMAIL.COM",
                ticketNumber: "1272189420552",
                memberNumber: "108016823",
                tier: "SMILES",
                quantityBaggage: { free: "1", purchased: "0", available: "5" },
                status: "HK",
                nationality: "Brazilian",
                nameReferenceNumber: "01.01",
                requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
                documentList: [{ number: "31124999809", type: "CPF" }],
              },
            ],
          },
        ],
        passengerList: [
          {
            index: "0",
            type: "ADT",
            firstName: "ALINE LORENA MAITE DA",
            lastName: "CONCEICAO",
            gender: "FEMALE",
            birthday: "1999-01-01",
            email: "TESTE1NOVO2023@GMAIL.COM",
            ticketNumber: "1272189420552",
            memberNumber: "108016823",
            tier: "SMILES",
            status: "HK",
            nationality: "Brazilian",
            nameReferenceNumber: "01.01",
            requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
            documentList: [{ number: "31124999809", type: "CPF" }],
            ancillaryList: [
              {
                id: "22",
                commercialName: "BILHETE PREMIO VOEBIZ",
                code: "D",
                subCode: "PVB",
                vendor: "MMGR",
                EMD: "1274405255488",
                EMDType: "2",
                EMDName: "Associated",
                serviceType: "F",
                basePrice: { currencyCode: "BRL", value: "0.74" },
                taxesPrice: { currencyCode: "BRL", value: "0.00" },
                totalPrice: { currencyCode: "BRL", value: "0.74" },
                groupCode: "FF",
                refundableIndicator: "Y",
                commissionIndicator: "N",
                segmentIndicator: "S",
                interlineIndicator: "Y",
                consumedIndicator: "N",
                ticketNumber: "1274405255488",
                couponNumber: "01",
                segments: {
                  segment: {
                    segmentId: "1",
                    segmentNumber: "1",
                    flight: {
                      flightId: "1",
                      airline: "G3",
                      number: "1002",
                      departureAirport: "CGH",
                      departureDate: "2023-06-30",
                      departureTime: "06:40:00",
                      arrivalAirport: "SDU",
                      arrivalDate: "2023-06-30",
                      arrivalTime: "07:40:00",
                      operatingAirline: "G3",
                      operatingFlightNumber: "1002",
                      classOfService: "N",
                      operatingClassOfService: "N",
                      cabin: "Y",
                      reservationStatus: "HK",
                    },
                    inboundConnection: "false",
                    outboundConnection: "false",
                    emdNumber: "1274405255488",
                    couponNumber: "01",
                  },
                },
              },
            ],
          },
        ],
      },
      bookingStatus: "CONFIRMED",
      balanceDue: "407.83",
      isLegacy: "false",
      orderId: "13599229",
      isAllowedBaggage: "true",
      dateTimeCreation: "2023-05-22T10:50:00",
      isAutoCancelled: "false",
      chosenFareList: [
        {
          type: "SMILES",
          money: "367.90",
          taxes: "39.93",
          g3: { classOfService: "N", classType: "LT", ruleTariff: {}, ruleNumber: "1", fareBasisCode: "NOIAAG2G" },
        },
      ],
      ancillaryList: [
        {
          id: "22",
          commercialName: "BILHETE PREMIO VOEBIZ",
          code: "D",
          subCode: "PVB",
          vendor: "MMGR",
          EMD: "1274405255488",
          EMDType: "2",
          EMDName: "Associated",
          serviceType: "F",
          basePrice: { currencyCode: "BRL", value: "0.74" },
          taxesPrice: { currencyCode: "BRL", value: "0.00" },
          totalPrice: { currencyCode: "BRL", value: "0.74" },
          groupCode: "FF",
          refundableIndicator: "Y",
          commissionIndicator: "N",
          segmentIndicator: "S",
          interlineIndicator: "Y",
          consumedIndicator: "N",
          ticketNumber: "1274405255488",
          couponNumber: "01",
          passengers: {
            passenger: {
              index: "0",
              nameReferenceNumber: "01.01",
              passengerId: "1",
              passengerType: "ADT",
              firstName: "ALINE LORENA MAITE DA",
              lastName: "CONCEICAO",
            },
          },
          segments: {
            segment: {
              segmentId: "1",
              segmentNumber: "1",
              flight: {
                flightId: "1",
                airline: "G3",
                number: "1002",
                departureAirport: "CGH",
                departureDate: "2023-06-30",
                departureTime: "06:40:00",
                arrivalAirport: "SDU",
                arrivalDate: "2023-06-30",
                arrivalTime: "07:40:00",
                operatingAirline: "G3",
                operatingFlightNumber: "1002",
                classOfService: "N",
                operatingClassOfService: "N",
                cabin: "Y",
                reservationStatus: "HK",
              },
              inboundConnection: "false",
              outboundConnection: "false",
              emdNumber: "1274405255488",
              couponNumber: "01",
            },
          },
        },
      ],
    },
    {
      flight: {
        source: "G3",
        GDS: "GWS",
        tripType: "MULTIPLE_SEGMENTS",
        ruleTextReference:
          "eyJidWNrZXQiOiJjZnN0YWNrLWhtbDUtc21pbGVzLWxhbWJkYS1mbGlnaHQtYXZhaWxhYmlsaXR5LWZsaWdodHJ1bGV0ZXh0L0JSQVNJTC8xMzYwMDc1MV8xMDgwMTY4MjMuanNvbiIsICJydWxlVGV4dCI6WyJoYTU1bnZsOTVnIl19",
        isInvoluntaryCancel: "false",
        whatsapp: { sendWhatsapp: false, ddi: "", ddd: "", number: "" },
        routeList: [{ originAirportCode: "GRU", destinationAirportCode: "GIG", departureDate: "2023-06-30T09:55:00" }],
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              stops: "0",
              cabin: "ECONOMIC",
              cabinCode: "Y",
              cabinCodeSabre: "Y",
              airline: { code: "G3", name: "GOL" },
              departure: {
                date: "2023-06-30T09:55:00",
                airport: {
                  code: "GRU",
                  name: "Guarulhos",
                  city: "São Paulo",
                  mac: "SAO",
                  timeZone: "America/Sao_Paulo",
                  state: "São Paulo",
                  country: "Brasil",
                },
              },
              arrival: {
                date: "2023-06-30T10:50:00",
                airport: {
                  code: "GIG",
                  name: "Galeão/Antonio Carlos Jobim",
                  city: "Rio de Janeiro",
                  state: "Rio de Janeiro",
                  country: "Brasil",
                },
              },
              duration: { hours: "0", minutes: "55" },
              flightSellKey: "WPMBRL$AC*VOEBIZ$P2ADT$BRLT$RQ",
              legList: [
                {
                  cabin: "ECONOMIC",
                  departure: {
                    date: "2023-06-30T09:55:00",
                    airport: {
                      code: "GRU",
                      name: "Guarulhos",
                      city: "São Paulo",
                      mac: "SAO",
                      timeZone: "America/Sao_Paulo",
                      state: "São Paulo",
                      country: "Brasil",
                    },
                  },
                  arrival: {
                    date: "2023-06-30T10:50:00",
                    airport: {
                      code: "GIG",
                      name: "Galeão/Antonio Carlos Jobim",
                      city: "Rio de Janeiro",
                      state: "Rio de Janeiro",
                      country: "Brasil",
                    },
                  },
                  flightNumber: "1092",
                  marketingAirline: { code: "G3", name: "GOL" },
                  operationAirline: { code: "G3", name: "GOL" },
                  equipment: "738",
                  isConnection: "false",
                  productClass: "N",
                  statusCode: "HK",
                  operatingProductClass: "N",
                  marketingProductClass: "N",
                  inboundConnection: "false",
                  outboundConnection: "false",
                },
              ],
            },
            recordLocator: "IDXMVE",
            baggageList: {},
            availableBaggageList: {},
            checkin: "UNAVAILABLE",
            travelType: "NATIONAL",
            isAllowedBaggage: "true",
            migratedRecordLocator: "IDXMVE",
            passengerList: [
              {
                index: "0",
                type: "ADT",
                firstName: "ALINE LORENA MAITE DA",
                lastName: "CONCEICAO",
                gender: "FEMALE",
                birthday: "2001-01-01",
                email: "TESTE1NOVO2023@GMAIL.COM",
                ticketNumber: "1272189424019",
                memberNumber: "108016823",
                tier: "SMILES",
                quantityBaggage: { free: "0", purchased: "0", available: "0" },
                status: "HK",
                nationality: "Brazilian",
                nameReferenceNumber: "01.01",
                requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
                documentList: [{ number: "31124999809", type: "CPF" }],
              },
              {
                index: "1",
                type: "ADT",
                firstName: "ALBERTO",
                lastName: "BRUNO",
                gender: "MALE",
                birthday: "2000-04-02",
                ticketNumber: "1272189424020",
                quantityBaggage: { free: "0", purchased: "0", available: "0" },
                status: "HK",
                nationality: "Brazilian",
                nameReferenceNumber: "02.01",
                requestSpecialServiceList: ["TKNE", "BRND"],
              },
            ],
          },
        ],
        passengerList: [
          {
            index: "0",
            type: "ADT",
            firstName: "ALINE LORENA MAITE DA",
            lastName: "CONCEICAO",
            gender: "FEMALE",
            birthday: "2001-01-01",
            email: "TESTE1NOVO2023@GMAIL.COM",
            ticketNumber: "1272189424019",
            memberNumber: "108016823",
            tier: "SMILES",
            status: "HK",
            nationality: "Brazilian",
            nameReferenceNumber: "01.01",
            requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
            documentList: [{ number: "31124999809", type: "CPF" }],
            ancillaryList: [
              {
                id: "34",
                commercialName: "BILHETE PREMIO VOEBIZ",
                code: "D",
                subCode: "PVB",
                vendor: "MMGR",
                EMD: "1274405256416",
                EMDType: "2",
                EMDName: "Associated",
                serviceType: "F",
                basePrice: { currencyCode: "BRL", value: "0.62" },
                taxesPrice: { currencyCode: "BRL", value: "0.00" },
                totalPrice: { currencyCode: "BRL", value: "0.62" },
                groupCode: "FF",
                refundableIndicator: "Y",
                commissionIndicator: "N",
                segmentIndicator: "S",
                interlineIndicator: "Y",
                consumedIndicator: "N",
                ticketNumber: "1274405256416",
                couponNumber: "01",
                segments: {
                  segment: {
                    segmentId: "1",
                    segmentNumber: "1",
                    flight: {
                      flightId: "1",
                      airline: "G3",
                      number: "1092",
                      departureAirport: "GRU",
                      departureDate: "2023-06-30",
                      departureTime: "09:55:00",
                      arrivalAirport: "GIG",
                      arrivalDate: "2023-06-30",
                      arrivalTime: "10:50:00",
                      operatingAirline: "G3",
                      operatingFlightNumber: "1092",
                      classOfService: "N",
                      operatingClassOfService: "N",
                      cabin: "Y",
                      reservationStatus: "HK",
                    },
                    inboundConnection: "false",
                    outboundConnection: "false",
                    emdNumber: "1274405256416",
                    couponNumber: "01",
                  },
                },
              },
            ],
          },
          {
            index: "1",
            type: "ADT",
            firstName: "ALBERTO",
            lastName: "BRUNO",
            gender: "MALE",
            birthday: "2000-04-02",
            ticketNumber: "1272189424020",
            nationality: "Brazilian",
            nameReferenceNumber: "02.01",
            requestSpecialServiceList: ["TKNE", "BRND"],
            ancillaryList: [
              {
                id: "36",
                commercialName: "BILHETE PREMIO VOEBIZ",
                code: "D",
                subCode: "PVB",
                vendor: "MMGR",
                EMD: "1274405256417",
                EMDType: "2",
                EMDName: "Associated",
                serviceType: "F",
                basePrice: { currencyCode: "BRL", value: "0.62" },
                taxesPrice: { currencyCode: "BRL", value: "0.00" },
                totalPrice: { currencyCode: "BRL", value: "0.62" },
                groupCode: "FF",
                refundableIndicator: "Y",
                commissionIndicator: "N",
                segmentIndicator: "S",
                interlineIndicator: "Y",
                consumedIndicator: "N",
                ticketNumber: "1274405256417",
                couponNumber: "01",
                segments: {
                  segment: {
                    segmentId: "1",
                    segmentNumber: "1",
                    flight: {
                      flightId: "1",
                      airline: "G3",
                      number: "1092",
                      departureAirport: "GRU",
                      departureDate: "2023-06-30",
                      departureTime: "09:55:00",
                      arrivalAirport: "GIG",
                      arrivalDate: "2023-06-30",
                      arrivalTime: "10:50:00",
                      operatingAirline: "G3",
                      operatingFlightNumber: "1092",
                      classOfService: "N",
                      operatingClassOfService: "N",
                      cabin: "Y",
                      reservationStatus: "HK",
                    },
                    inboundConnection: "false",
                    outboundConnection: "false",
                    emdNumber: "1274405256417",
                    couponNumber: "01",
                  },
                },
              },
            ],
          },
        ],
      },
      bookingStatus: "CONFIRMED",
      balanceDue: "849.06",
      isLegacy: "false",
      orderId: "13600751",
      isAllowedBaggage: "true",
      dateTimeCreation: "2023-05-24T07:33:00",
      isAutoCancelled: "false",
      chosenFareList: [
        {
          type: "SMILES",
          money: "394.90",
          taxes: "29.63",
          g3: { classOfService: "N", classType: "LT", ruleTariff: {}, ruleNumber: "1", fareBasisCode: "NNJAAG2G" },
        },
      ],
      ancillaryList: [
        {
          id: "34",
          commercialName: "BILHETE PREMIO VOEBIZ",
          code: "D",
          subCode: "PVB",
          vendor: "MMGR",
          EMD: "1274405256416",
          EMDType: "2",
          EMDName: "Associated",
          serviceType: "F",
          basePrice: { currencyCode: "BRL", value: "0.62" },
          taxesPrice: { currencyCode: "BRL", value: "0.00" },
          totalPrice: { currencyCode: "BRL", value: "0.62" },
          groupCode: "FF",
          refundableIndicator: "Y",
          commissionIndicator: "N",
          segmentIndicator: "S",
          interlineIndicator: "Y",
          consumedIndicator: "N",
          ticketNumber: "1274405256416",
          couponNumber: "01",
          passengers: {
            passenger: [
              {
                index: "0",
                nameReferenceNumber: "01.01",
                passengerId: "1",
                passengerType: "ADT",
                firstName: "ALINE LORENA MAITE DA",
                lastName: "CONCEICAO",
              },
              {
                index: "1",
                nameReferenceNumber: "02.01",
                passengerId: "2",
                passengerType: "ADT",
                firstName: "ALBERTO",
                lastName: "BRUNO",
              },
            ],
          },
          segments: {
            segment: {
              segmentId: "1",
              segmentNumber: "1",
              flight: {
                flightId: "1",
                airline: "G3",
                number: "1092",
                departureAirport: "GRU",
                departureDate: "2023-06-30",
                departureTime: "09:55:00",
                arrivalAirport: "GIG",
                arrivalDate: "2023-06-30",
                arrivalTime: "10:50:00",
                operatingAirline: "G3",
                operatingFlightNumber: "1092",
                classOfService: "N",
                operatingClassOfService: "N",
                cabin: "Y",
                reservationStatus: "HK",
              },
              inboundConnection: "false",
              outboundConnection: "false",
              emdNumber: "1274405256416",
              couponNumber: "01",
            },
          },
        },
        {
          id: "36",
          commercialName: "BILHETE PREMIO VOEBIZ",
          code: "D",
          subCode: "PVB",
          vendor: "MMGR",
          EMD: "1274405256417",
          EMDType: "2",
          EMDName: "Associated",
          serviceType: "F",
          basePrice: { currencyCode: "BRL", value: "0.62" },
          taxesPrice: { currencyCode: "BRL", value: "0.00" },
          totalPrice: { currencyCode: "BRL", value: "0.62" },
          groupCode: "FF",
          refundableIndicator: "Y",
          commissionIndicator: "N",
          segmentIndicator: "S",
          interlineIndicator: "Y",
          consumedIndicator: "N",
          ticketNumber: "1274405256417",
          couponNumber: "01",
          passengers: {
            passenger: [
              {
                index: "0",
                nameReferenceNumber: "01.01",
                passengerId: "1",
                passengerType: "ADT",
                firstName: "ALINE LORENA MAITE DA",
                lastName: "CONCEICAO",
              },
              {
                index: "1",
                nameReferenceNumber: "02.01",
                passengerId: "2",
                passengerType: "ADT",
                firstName: "ALBERTO",
                lastName: "BRUNO",
              },
            ],
          },
          segments: {
            segment: {
              segmentId: "1",
              segmentNumber: "1",
              flight: {
                flightId: "1",
                airline: "G3",
                number: "1092",
                departureAirport: "GRU",
                departureDate: "2023-06-30",
                departureTime: "09:55:00",
                arrivalAirport: "GIG",
                arrivalDate: "2023-06-30",
                arrivalTime: "10:50:00",
                operatingAirline: "G3",
                operatingFlightNumber: "1092",
                classOfService: "N",
                operatingClassOfService: "N",
                cabin: "Y",
                reservationStatus: "HK",
              },
              inboundConnection: "false",
              outboundConnection: "false",
              emdNumber: "1274405256417",
              couponNumber: "01",
            },
          },
        },
      ],
    },
    {
      flight: {
        source: "G3",
        GDS: "GWS",
        tripType: "MULTIPLE_SEGMENTS",
        ruleTextReference:
          "eyJidWNrZXQiOiJjZnN0YWNrLWhtbDUtc21pbGVzLWxhbWJkYS1mbGlnaHQtYXZhaWxhYmlsaXR5LWZsaWdodHJ1bGV0ZXh0L0JSQVNJTC8xMzU5OTI1MF8xMDgwMTY4MjMuanNvbiIsICJydWxlVGV4dCI6WyI4NG1scnhrM25uOSJdfQ==",
        isInvoluntaryCancel: "false",
        whatsapp: { sendWhatsapp: false, ddi: "", ddd: "", number: "" },
        routeList: [{ originAirportCode: "CGH", destinationAirportCode: "SDU", departureDate: "2023-10-31T06:40:00" }],
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              stops: "0",
              cabin: "ECONOMIC",
              cabinCode: "Y",
              cabinCodeSabre: "Y",
              airline: { code: "G3", name: "GOL" },
              departure: {
                date: "2023-10-31T06:40:00",
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "São Paulo",
                  mac: "SAO",
                  timeZone: "America/Sao_Paulo",
                  state: "São Paulo",
                  country: "Brasil",
                },
              },
              arrival: {
                date: "2023-10-31T07:40:00",
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                  state: "Rio de Janeiro",
                  country: "Brasil",
                },
              },
              duration: { hours: "1", minutes: "0" },
              flightSellKey: "WPMBRL$AC*VOEBIZ$P1ADT$BRPO$RQ",
              legList: [
                {
                  cabin: "ECONOMIC",
                  departure: {
                    date: "2023-10-31T06:40:00",
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "São Paulo",
                      mac: "SAO",
                      timeZone: "America/Sao_Paulo",
                      state: "São Paulo",
                      country: "Brasil",
                    },
                  },
                  arrival: {
                    date: "2023-10-31T07:40:00",
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                      state: "Rio de Janeiro",
                      country: "Brasil",
                    },
                  },
                  flightNumber: "1002",
                  marketingAirline: { code: "G3", name: "GOL" },
                  operationAirline: { code: "G3", name: "GOL" },
                  equipment: "738",
                  isConnection: "false",
                  productClass: "O",
                  statusCode: "HK",
                  operatingProductClass: "O",
                  marketingProductClass: "O",
                  inboundConnection: "false",
                  outboundConnection: "false",
                },
              ],
            },
            recordLocator: "NHULGW",
            baggageList: {
              passengerBaggage: {
                passenger: {
                  uid: "01.01",
                  index: "0",
                  type: "ADT",
                  firstName: "ALINE LORENA MAITE DA",
                  lastName: "CONCEICAO",
                  tier: "SMILES",
                },
                baggage: {
                  code: "0C9",
                  quantity: "1",
                  amount: "0",
                  weight: "45",
                  maxWeight: "45",
                  keyValue: "EXCESSO DE BAGAGEM POR KILO",
                },
                miles: "0",
                money: "0",
                smilesAndMoneyList: {},
                type: "FREE",
              },
            },
            availableBaggageList: {
              passengerBaggage: [
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA1",
                    quantity: "2",
                    amount: "95",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "PRIMEIRA BAGAGEM",
                  },
                  miles: "6200",
                  money: "95",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "5700", money: "21" },
                      { miles: "5000", money: "32" },
                      { miles: "2200", money: "74" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA2",
                    quantity: "3",
                    amount: "224",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "SEGUNDA BAGAGEM",
                  },
                  miles: "14600",
                  money: "224",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "13500", money: "50" },
                      { miles: "11800", money: "74" },
                      { miles: "5100", money: "173" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA3",
                    quantity: "4",
                    amount: "404",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "TERCEIRA BAGAGEM",
                  },
                  miles: "26300",
                  money: "404",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "24300", money: "89" },
                      { miles: "21300", money: "134" },
                      { miles: "9100", money: "312" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA4",
                    quantity: "5",
                    amount: "584",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "QUARTA A QUINTA BAGAGEM CADA",
                  },
                  miles: "38000",
                  money: "584",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "35100", money: "129" },
                      { miles: "30700", money: "193" },
                      { miles: "13200", money: "450" },
                    ],
                  },
                  type: "AVAILABLE",
                },
                {
                  passenger: {
                    uid: "01.01",
                    index: "0",
                    type: "ADT",
                    firstName: "ALINE LORENA MAITE DA",
                    lastName: "CONCEICAO",
                    tier: "SMILES",
                  },
                  baggage: {
                    code: "BA5",
                    quantity: "6",
                    amount: "764",
                    weight: "23",
                    maxWeight: "23",
                    keyValue: "QUARTA A QUINTA BAGAGEM CADA",
                  },
                  miles: "49700",
                  money: "764",
                  smilesAndMoneyList: {
                    smilesAndMoney: [
                      { miles: "45900", money: "169" },
                      { miles: "40200", money: "253" },
                      { miles: "17200", money: "589" },
                    ],
                  },
                  type: "AVAILABLE",
                },
              ],
            },
            checkin: "UNAVAILABLE",
            travelType: "NATIONAL",
            isAllowedBaggage: "true",
            migratedRecordLocator: "NHULGW",
            passengerList: [
              {
                index: "0",
                type: "ADT",
                firstName: "ALINE LORENA MAITE DA",
                lastName: "CONCEICAO",
                gender: "FEMALE",
                birthday: "1999-11-01",
                email: "TESTE1NOVO2023@GMAIL.COM",
                ticketNumber: "1272189420665",
                memberNumber: "108016823",
                tier: "SMILES",
                quantityBaggage: { free: "1", purchased: "0", available: "5" },
                status: "HK",
                nationality: "Brazilian",
                nameReferenceNumber: "01.01",
                requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
                documentList: [{ number: "31124999809", type: "CPF" }],
              },
            ],
          },
        ],
        passengerList: [
          {
            index: "0",
            type: "ADT",
            firstName: "ALINE LORENA MAITE DA",
            lastName: "CONCEICAO",
            gender: "FEMALE",
            birthday: "1999-11-01",
            email: "TESTE1NOVO2023@GMAIL.COM",
            ticketNumber: "1272189420665",
            memberNumber: "108016823",
            tier: "SMILES",
            status: "HK",
            nationality: "Brazilian",
            nameReferenceNumber: "01.01",
            requestSpecialServiceList: ["FQTR", "TKNE", "BRND"],
            documentList: [{ number: "31124999809", type: "CPF" }],
            ancillaryList: [
              {
                id: "25",
                commercialName: "BILHETE PREMIO VOEBIZ",
                code: "D",
                subCode: "PVB",
                vendor: "MMGR",
                EMD: "1274405255512",
                EMDType: "2",
                EMDName: "Associated",
                serviceType: "F",
                basePrice: { currencyCode: "BRL", value: "2.30" },
                taxesPrice: { currencyCode: "BRL", value: "0.00" },
                totalPrice: { currencyCode: "BRL", value: "2.30" },
                groupCode: "FF",
                refundableIndicator: "Y",
                commissionIndicator: "N",
                segmentIndicator: "S",
                interlineIndicator: "Y",
                consumedIndicator: "N",
                ticketNumber: "1274405255512",
                couponNumber: "01",
                segments: {
                  segment: {
                    segmentId: "1",
                    segmentNumber: "1",
                    flight: {
                      flightId: "1",
                      airline: "G3",
                      number: "1002",
                      departureAirport: "CGH",
                      departureDate: "2023-10-31",
                      departureTime: "06:40:00",
                      arrivalAirport: "SDU",
                      arrivalDate: "2023-10-31",
                      arrivalTime: "07:40:00",
                      operatingAirline: "G3",
                      operatingFlightNumber: "1002",
                      classOfService: "O",
                      operatingClassOfService: "O",
                      cabin: "Y",
                      reservationStatus: "HK",
                    },
                    inboundConnection: "false",
                    outboundConnection: "false",
                    emdNumber: "1274405255512",
                    couponNumber: "01",
                  },
                },
              },
            ],
          },
        ],
      },
      bookingStatus: "CONFIRMED",
      balanceDue: "165.83",
      isLegacy: "false",
      orderId: "13599250",
      isAllowedBaggage: "true",
      dateTimeCreation: "2023-05-22T10:59:00",
      isAutoCancelled: "false",
      chosenFareList: [
        {
          type: "SMILES",
          money: "125.90",
          taxes: "39.93",
          g3: { classOfService: "O", classType: "PO", ruleTariff: {}, ruleNumber: "1", fareBasisCode: "ONJIAG1G" },
        },
      ],
      ancillaryList: [
        {
          id: "25",
          commercialName: "BILHETE PREMIO VOEBIZ",
          code: "D",
          subCode: "PVB",
          vendor: "MMGR",
          EMD: "1274405255512",
          EMDType: "2",
          EMDName: "Associated",
          serviceType: "F",
          basePrice: { currencyCode: "BRL", value: "2.30" },
          taxesPrice: { currencyCode: "BRL", value: "0.00" },
          totalPrice: { currencyCode: "BRL", value: "2.30" },
          groupCode: "FF",
          refundableIndicator: "Y",
          commissionIndicator: "N",
          segmentIndicator: "S",
          interlineIndicator: "Y",
          consumedIndicator: "N",
          ticketNumber: "1274405255512",
          couponNumber: "01",
          passengers: {
            passenger: {
              index: "0",
              nameReferenceNumber: "01.01",
              passengerId: "1",
              passengerType: "ADT",
              firstName: "ALINE LORENA MAITE DA",
              lastName: "CONCEICAO",
            },
          },
          segments: {
            segment: {
              segmentId: "1",
              segmentNumber: "1",
              flight: {
                flightId: "1",
                airline: "G3",
                number: "1002",
                departureAirport: "CGH",
                departureDate: "2023-10-31",
                departureTime: "06:40:00",
                arrivalAirport: "SDU",
                arrivalDate: "2023-10-31",
                arrivalTime: "07:40:00",
                operatingAirline: "G3",
                operatingFlightNumber: "1002",
                classOfService: "O",
                operatingClassOfService: "O",
                cabin: "Y",
                reservationStatus: "HK",
              },
              inboundConnection: "false",
              outboundConnection: "false",
              emdNumber: "1274405255512",
              couponNumber: "01",
            },
          },
        },
      ],
    },
  ],
};
